import React from 'react';

import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import {
  propTypes,
  LINE_ITEM_SHIPPING_FEE,
  LINE_ITEM_PICKUP_FEE,
  LISTING_UNIT_TYPES,
} from '../../util/types';
import useLineItemsTotal from '../../hooks/useLineItemsTotal';

import css from './OrderBreakdown.module.css';

const NON_COMMISSION_LINE_ITEMS = [
  ...LISTING_UNIT_TYPES,
  LINE_ITEM_SHIPPING_FEE,
  LINE_ITEM_PICKUP_FEE,
];

const LineItemRefundMaybe = props => {
  const { lineItems, intl, marketplaceCurrency } = props;

  const refund = useLineItemsTotal(lineItems, NON_COMMISSION_LINE_ITEMS, true, marketplaceCurrency);
  const formattedRefund = refund && refund.amount !== 0 ? formatMoney(intl, refund) : null;

  return formattedRefund ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id="OrderBreakdown.refund" />
      </span>
      <span className={css.itemValue}>{formattedRefund}</span>
    </div>
  ) : null;
};

LineItemRefundMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemRefundMaybe;
